<template>
    <div id="downloadDoc">
        <my-header></my-header>
        <div class="banner">
            <img src="../../../assets/images/backStandard/topBg.jpg"/>
            <div class="main-container">
                <div class="bannerText">
                    <h2>{{ projectName }}<span>下载标书</span></h2>
                </div>
            </div>
        </div>
        <div class="main-container mainWrap">
            <section class="small-container">
                <h2>
                    <img src="../../../assets/images/invitemanage/tit02.png"/>
                    <!--<el-button type="primary"><i class="downloadIcon"></i>下载全部</el-button>-->
                </h2>
                <el-table
                    :data="tableData"
                    tooltip-effect="light"
                    style="width: 100%">
                    <el-table-column
                        type="index"
                        label="序号"
                        width="120">
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        label="文件名称">
                        <template slot-scope="scope">
                            <a class="words" href="javascript:;" @click="fileListHandleDownload(scope.row)" title="点击下载">
                                {{ scope.row.attachName}}
                            </a>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="downTime"
                        label="下载日期">
                    </el-table-column>
                </el-table>
            </section>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'downloadDoc',
        data() {
            return {
                projectName: '',//项目名称
                tableData: []//标书文件
            }
        },
        created(){
            this.$root.activeIndex = 'win';
           this.getList();//初始化列表；
        },
        methods: {
            getList(){
                let that = this;
                this.$root.postHttp('/v1/outerformflow/bidFile/list',{
                    formId: this.$route.params.formId,
                    type: this.$route.params.type//第一次发标文件 1，二轮发标文件 2 ,不写默认查出所有
                },function (res) {
                    that.tableData = res.data.data.attachments;
                    that.projectName = res.data.data.dealBisVo.flowFormExtMng.formTitle;
                })
            },
            fileListHandleDownload(val) {
                 let that = this;
                that.$confirm('确定下载该附件吗?',{
                    type:'warning',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then( () => {
                    that.$root.postHttp('/v1/outerformflow/bidFile/down',{
                        formId: val.formId,
                        id: val.id,
                        type: val.attachmentType
                    },function (res) {
                        console.log(val,res)
                        // debugger
                        //code 1 成功了再进行下载
                        that.$root.downloadFile({
                            attachName: val.attachName,
                            attachPath: val.attachPath
                        });
                        that.getList();
                    });
                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消下载'
                    })
                });
            }
        }
    }
</script>
<style lang="scss">
@import "../../../assets/var";
#downloadDoc {
    padding-bottom: 50px;
    background: $--primary-fill-color;
    & .head-top{
        background: #fff;
    }
    & .head-right {
        color: $--text-color-light;
        & .login {
            background: url('../../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
        }
        & .register {
            background: url('../../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
        }
        & .line {
            background: $--text-color-light;
        }
        & .help {
            background: url('../../../assets/images/topBar2/icon05.png') no-repeat;
        }
        & .wechat {
            background: url('../../../assets/images/topBar2/icon06.png') no-repeat;
        }
    }
    .banner {
        margin-top: 80px;
        img {
            width: 100%;
        }
        .main-container {
            position: relative;
            .bannerText {
                position: absolute;
                left: 0;
                top: -50px;
                width: 100%;
                color: #fff;
                line-height: 34px;
                h2 {
                    float: left;
                    font-size: 18px;
                    span {
                        display: inline-block;
                        vertical-align: middle;
                        border: 1px solid #fff;
                        padding: 0 8px;
                        margin-left: 15px;
                        height: 24px;
                        font-size: 14px;
                        line-height: 22px;
                        border-radius: 4px;
                        font-weight: normal;
                        box-sizing: border-box;
                    }
                }
                p {
                    float: right;
                    font-size: 14px;
                }
            }
        }
    }
    .mainWrap {
        position: relative;
        margin-top: 40px;
        padding: 30px 0 60px;
        background: #fff;
    }
    .small-container {
        width: 1040px;
        margin: 0 auto;
        h2 {
            margin-top: 20px;
            overflow: hidden;
            img {
                float: left;
                width: 282px;
                height: 30px;
            }
            .el-button {
                float: right;
                padding: 6px 10px;
                height: 30px;
                i {
                    display: inline-block;
                    margin-right: 3px;
                    width: 18px;
                    height: 18px;
                    vertical-align: middle;
                }
                .downloadIcon {
                    background: url('../../../assets/images/backStandard/icon01.png') no-repeat;
                }
            }
        }
        .el-table{
            margin-top: 20px;
            th {
              text-align: center;
            }
            & .words {
                color: #333;
                text-decoration: none;
            }
            & .words:hover {
                color: $--primary-color;
                text-decoration: underline;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/master/inviteProcess/DownloadDoc.vue